import { cn } from '@/utils/cn';
import React from 'react';

const ModalContent = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('overflow-y-auto flex-1 overflow-x-hidden mt-[16px] pr-[12px]', className)}
      {...props}
    />
  );
});
ModalContent.displayName = 'ModalContent';

export { ModalContent };
